import { CartViewEvent } from '@/usecases/event-bus-for-third-party/event'

export function handleCartViewEvent(event: CartViewEvent): void {
  /**
   * これがGA4の推奨イベント的なものらしいので美ラボ・ホテラバ以外もこのフォーマットへ移行したい
   * @see https://github.com/Everforth/growthpalette-front/issues/8263
   */
  window.dataLayer.push({
    event: 'addToCart',
    ecommerce: {
      add: {
        products: event.wholeItems.map(cartItem => ({
          item_id: cartItem.skuId,
          item_name: cartItem.name,
          item_variant: cartItem.color || '',
          price: cartItem.unitPrice,
          quantity: cartItem.unitCount,
        })),
      },
    },
  })
}
